import React, {useState, useEffect} from "react";
import CalendarTime from "../Components/CalendarTIme";
import CalendarService from "../Services/Calendar";
import moment from "moment";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

const CalService = new CalendarService();

const Calendar = (props) => {
    let city = "";
    if (document.getElementById("calendar-block") !== null) {
        city = document.getElementById("calendar-block").attributes.getNamedItem("data-city").value;
    }

    useEffect(() => {
        $("#datepicker").datepicker({
            language: 'ru',
            autoClose: true,
            //range: true,
            multipleDatesSeparator: " - ",
            minDate: new Date(),
            position: 'bottom left'
        });

        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    const [render, setRender] = useState(0);
    const [lastDate, setLastDate] = useState(null);

    if(render != props.countRender) {
        CalService.getDates(lastDate, city).then(res => {
            setDates(res);
            setLoading(false);
        });

        setRender(props.countRender);
    }

    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(true);

    const onClickSetDate = () => {
        const picker = document.getElementById("datepicker");

        CalService.getDates(picker.value, city).then(res => {
            setDates(res);
            setLoading(false);
        });
    };

    const onChangeWeek = (e, type) => {
        e.preventDefault();

        const picker = document.getElementById("datepicker");

        setLoading(true);
        let date = moment(dates[0].date.value, "DD.MM.YYYY");

        if(type == "next") {
            date.add(7, "day");
        } else {
            date.subtract(7, "day");
        }
        setLastDate(date.format("DD.MM.YYYY"));

        picker.value = "";
        CalService.getDates(date.format("DD.MM.YYYY"), city).then(res => {
            setDates(res);
            setLoading(false);
        });
    };

    return (
        <>
            <BlockUi tag="div" blocking={loading}>
                <div className="form-table-top">
                    <div className="form-row align-items-center">
                        <div className="col-md-6 col-sm-12">
                            <div className="form-inline justify-content-center">
                                <div className="form-group form-item mb-2 mx-sm-2 date-field">
                                    <input id="datepicker" className="date-select form-control" type="text"
                                           placeholder="Выберите дату"/>
                                    <i className="far fa-calendar-alt"/>
                                </div>
                                <div className="form-button mb-2">
                                    <button onClick={onClickSetDate} className="btn btn-secondary"
                                            type="button">Установить
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 order-md-first">
                            <div className="form-item">
                                <a onClick={e => onChangeWeek(e, "prev")} href="#">{'<<'}Предыдущая неделя</a>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <div onClick={e => onChangeWeek(e,"next")} className="form-item align-right"><a href="#">Следующая
                                неделя {'>>'}</a></div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered form-table">
                        <thead>
                            <tr>
                                <th></th>
                                {dates.map(item => (
                                    <th key={item.date.value}>{item.date.name}</th>
                                ))}
                            </tr>

                            <tr>
                                <th>Выберите время начала:</th>
                                {dates.map(item => (
                                    <th key={item.date.value} className="table-date">{item.date.value}</th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {dates.length && dates[0].items.map(time => (
                                <tr key={time.value}>
                                    <th className="table-time">{time.value}</th>

                                    {dates.map(day => <CalendarTime reserved={props.reserved} reservedItem={props.reservedItem} onClickReserve={props.onClickReserve} onClickCancelReserve={props.onClickCancelReserve} key={day.date.value + time.value} day={day} time={time.value} />)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </BlockUi>
        </>
    );
};

export default Calendar;